<template>
<div id="app" ref="appbox">
    <router-view v-wechat-title="$route.meta.title"></router-view>
    <div class="tip">
        为了您的良好体验，请将手机/平板竖屏操作
    </div>
</div>
</template>

<script>
export default {
    name: 'App',
    data() {
        return {
            abc: 0
        }
    },
    mounted() {
        const that = this;
        window.addEventListener("resize", () => {
            setTimeout(() => {
                // let width = document.documentElement.clientWidth
                // let height = document.documentElement.clientHeight;
                // 横屏
                // if (width > height) {
                //     document.getElementById('app').style.height = '100%';
                // }else{ // 竖屏
                document.getElementById('app').style.height = window.innerHeight + "px";
                // }
            }, 200)
        })
    },
    watch: {
        '$route': function (to, from) {
            const that = this;
            setTimeout(() => {
                that.$refs.appbox.style.height = window.innerHeight + "px";
                console.log(window.innerHeight)
            }, 300)
        }
    }

}
</script>

<style lang="less">
#app {
    position: fixed;
    bottom: 0;
    left: 0;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    width: 100vw;
    height: 100vh;
    overflow: hidden;
    color: #333;

    .tip {
        display: none;
    }
}

@media screen and (orientation: landscape) {
    #app {

        // height: 2000px !important;
        // bottom: auto !important;
        // left: auto !important;
        // overflow: auto;
        .main {
            // display: none;
        }

        // .tip{
        //   position: fixed;
        //   top: 0;
        //   left: 0;
        //   width: 100%;
        //   height: 100vh;
        //   z-index: 10000;
        //   background: #fff;
        //   display: block;
        //   font-size: 22px;
        //   line-height: 100vh;
        //   text-align: center;
        // }
    }
}

// .md-popup{
//     background: #000;
// }
</style>



// WEBPACK FOOTER //
// src/App.vue